import { toast } from "react-toastify";
import { base_url, endpoints } from "../../Api/configs";
import { getLoginData } from "../AppStoreData";
import { parseResponseBody } from "../../services/apiClient";

export async function getHelpTicketsAPI(lastEvaluatedKey = null, limit = 10) {
  const data = await getLoginData();
  const url = `${base_url}${endpoints.help.getAllHelpTickets}`;
  const bodyParams = {
    accessToken: data.AccessToken,
    lastEvaluatedKey,
    limit,
  };

  try {
    const res = await fetch(url, {
      mode: "cors",
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ body: bodyParams }),
    });

    let response = await res.json();
    response = parseResponseBody(response);

    if (res.status === 200 && response.statusCode === 200) {
      return {
        tickets: response.tickets,
        lastEvaluatedKey: response.lastEvaluatedKey
          ? response.lastEvaluatedKey
          : "",
        count: response.count ? response.count : 58,
      };
    } else {
      toast.error(response.error);
    }
  } catch (error) {
    toast.error(error.message);
  }
}
